// composables/useFromPath.js

export const FROM_PATH_COOKIE_OPTIONS = {
  maxAge: 60 * 10,
  sameSite: 'lax',
  path: '/',
}

// 로그인/가입 흐름 페이지, 로그아웃·회원탈퇴 페이지는 로그인 후 돌아갈 페이지로 저장하지 않는다
const IGNORE_PATHS = ['/login', '/loginId', '/passLogin', '/join', '/appleJoin', '/fiId', '/fiPw', '/home', '/mypage/account']
const IGNORE_PREFIXES = ['/auth/']

export const isFromPathIgnored = (path = '') => {
  const purePath = path.split('?')[0].replace(/^\/view(?=\/)/, '')
  return IGNORE_PATHS.includes(purePath) || IGNORE_PREFIXES.some((prefix) => purePath.startsWith(prefix))
}

export const useFromPath = () => {
  const router = useRouter()
  const route = useRoute()

  const fromPathCookie = useCookie('fromPath', FROM_PATH_COOKIE_OPTIONS)

  const saveFromPath = (path = null) => {
  const target = path || route.fullPath
  if (!isFromPathIgnored(target)) {
    fromPathCookie.value = target
  }
}

  const navigateAfterPage = (fallback = '/home') => {
    const fromPath = fromPathCookie.value || fallback
    fromPathCookie.value = null
    router.replace(fromPath)
  }

  const navigateAfterPage2 = () => {
    if(fromPathCookie.value) {
      const fromPath = fromPathCookie.value
      fromPathCookie.value = null
      router.push(fromPath)
    }
  }

  return { saveFromPath, navigateAfterPage, fromPathCookie }
}